import { createRouter, createWebHashHistory } from 'vue-router';
import { useLoginStore } from "./stores/login.js";

export const Routes = {
    LOGIN: '/login',
    LOGIN_PROFESSIONAL: '/login-professional',
    APPLIANCES: '/appliances',
    USERS: '/users',
    ANALYTICS: '/analytics',
    FIRST_ACCESS: '/first-access',
    ERROR: '/error',
    NOT_FOUND: '/notfound',
    ANALYTICS_WEBVIEW: '/analytics-webview',
    ANALYTICS_WEBVIEW_GLOBAL: '/analytics-global-webview',
}

async function fetchRoutes(login, router) {
    if (login.getAbacConfig) {
        login.addRoutesMenu(router);
    }
}

async function createDynamicRouter(login) {
    const routes = [
        {
            path: '/',
            name: 'default',
            redirect: Routes.APPLIANCES,
            meta: { requiresAuth: true },
        },
        {
            path: Routes.APPLIANCES,
            name: 'Appliances',
            component: () => import('./pages/Appliances.vue'),
            meta: { requiresAuth: true },
        },
        {
            path: Routes.LOGIN,
            name: 'login-smegcons',
            component: () => import('./pages/Login.vue'),
            meta: { requiresUnauth: true },
        },
        {
            path: Routes.LOGIN_PROFESSIONAL,
            name: 'login-smeg',
            component: () => import('./pages/Login.vue'),
            meta: { requiresUnauth: true },
        },
        {
            path: Routes.FIRST_ACCESS,
            name: 'first-access',
            component: () => import('./pages/FirstAccess.vue'),
            meta: { requiresUnauth: true },
        },
        {
            path: Routes.ERROR,
            name: 'error',
            component: () => import('./pages/Error.vue'),
            meta: { requiresUnauth: true },
        },
        {
            path: Routes.NOT_FOUND,
            name: 'notfound',
            component: () => import('./pages/NotFound.vue'),
            meta: { requiresUnauth: true },
        },
        {
            path: '/:pathMatch(.*)*',
            name: 'not-found',
            component: () => import('./pages/NotFound.vue'),
            meta: { requiresUnauth: true },
        },
        {
            path: `/${Routes.ANALYTICS_WEBVIEW}/:type/:id`,
            name: 'analytics-webview',
            component: () => import('./pages/AnalyticsWebview.vue'),
            meta: { requiresUnauth: true },
        },
        {
            path: Routes.ANALYTICS_WEBVIEW_GLOBAL,
            name: 'analytics-global-webview',
            component: () => import('./pages/AnalyticsGlobalWebview.vue'),
            meta: { requiresUnauth: true },
        },
    ];
    const router = createRouter({
        history: createWebHashHistory(),
        routes: [
            ...routes,
        ]
    });

    const dynamicRoutes = await fetchRoutes(login, router);
    router.beforeEach(async function (to, from, next) {
        const login = useLoginStore();
        if (to.meta.requiresAuth) {
            await login.checkToken(router)
            if (login.getAccessToken === null || login.checkExpiresDate()) {
                login.accessDeniedToggle = false;
                next(Routes.LOGIN);
            } else if (login.checkRoutePermission(to.path)) {
                login.accessDeniedToggle = false;
                next();
            } else {
                login.accessDeniedToggle = true;
                if (login.abac_config?.role_def?.device) {
                    next(Routes.USERS);
                } else {
                    next(Routes.APPLIANCES);
                }
            }
        } else {
            next();
        }
    });

    return router;
}

export default createDynamicRouter;